import { ApiBaseFront } from "../api-base-front";

type Params = {
  kijshopCd: string,
  shopOrderId: string,
  cfOrderId: string,
  oneStopOrderUser: string,
  status: string,
};

export class ApiCfLabOrder extends ApiBaseFront<{}> {
  constructor(param: Params) {
    const {
      kijshopCd,
      shopOrderId,
      ...defaultProps
    } = param;

    super(
      'POST',
      `/api/v1/request/${kijshopCd}/${shopOrderId}/complete`,
      'JSON',
      defaultProps,
    );
  }
}

type OlcParam = {
  kijshopCd: string,
  shopOrderId: string,
  cfOrderId: string,
  orderUser: string,
  status: string,
  prodAndFolder: string[],
  isDelivery: boolean,
  isCompImageOrder?: 1 | 0,
}
export class ApiOlcLabOrder extends ApiBaseFront<{}> {
  constructor(param: OlcParam) {
    const {
      kijshopCd,
      shopOrderId,
      ...defaultProps
    } = param;
    super(
      'POST',
      `/api/v1/request/${kijshopCd}/${shopOrderId}/olc/complete`,
      'JSON',
      {...defaultProps, isDelivery: defaultProps.isDelivery ? 1 : 0},
    );
  }
}
